import { Link } from 'react-router-dom';

export default function Footer() {
  const handleTopNavigation = (path: string) => {
    if (path === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  return (
    <footer className="bg-[#0a0f1e] text-white">
      {/* Gold top border */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <span className="font-serif-jp text-[#c9a84c] text-xs tracking-[0.3em] font-light block mb-1">GODO KAISHA</span>
              <span className="font-serif-jp text-white text-2xl tracking-[0.2em] font-medium">合同会社ＡＺ</span>
            </div>
            <p className="text-white/50 text-xs leading-relaxed tracking-wide font-sans">
              コールセンターの企画・運営・管理から<br />
              幅広い業務委託まで、<br />
              お客様のビジネスを全力でサポートします。
            </p>
            <div className="mt-8 flex items-center gap-1">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <div className="w-2 h-2 border border-[#c9a84c] rotate-45"></div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif-jp text-[#c9a84c] text-xs tracking-[0.3em] mb-6 uppercase">Navigation</h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'ホーム', path: '/' },
                { label: 'サービス紹介', path: '/services' },
                { label: '料金プラン', path: '/pricing' },
                { label: '会社概要', path: '/about' },
                { label: 'お問い合わせ', path: '/contact' },
                { label: 'プライバシーポリシー', path: '/privacy' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => handleTopNavigation(item.path)}
                  className="text-white/60 hover:text-[#c9a84c] text-xs tracking-widest transition-colors duration-300 font-sans whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif-jp text-[#c9a84c] text-xs tracking-[0.3em] mb-6 uppercase">Contact</h4>
            <div className="flex flex-col gap-4">
              <div>
                <span className="text-white/30 text-xs tracking-widest block mb-1">ADDRESS</span>
                <span className="text-white/70 text-xs leading-relaxed font-sans">
                  埼玉県三郷市高州３丁目１６４番地バンブーハイツ１０７
                </span>
              </div>
              <div>
                <span className="text-white/30 text-xs tracking-widest block mb-1">TEL</span>
                <a href="tel:09063405373" className="text-white/70 text-xs font-sans hover:text-[#c9a84c] transition-colors cursor-pointer">
                  090-6340-5373
                </a>
              </div>
              <div>
                <span className="text-white/30 text-xs tracking-widest block mb-1">MAIL</span>
                <a href="mailto:administrator@az-consulting-llc.com" className="text-white/70 text-xs font-sans hover:text-[#c9a84c] transition-colors break-all cursor-pointer">
                  administrator@az-consulting-llc.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs tracking-widest font-sans">
            &copy; 2025 合同会社ＡＺ All Rights Reserved.
          </p>
          <Link
            to="/privacy"
            onClick={() => handleTopNavigation('/privacy')}
            className="text-white/30 hover:text-[#c9a84c] text-xs tracking-widest font-sans transition-colors cursor-pointer whitespace-nowrap"
          >
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </footer>
  );
}
